import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLlvmComponent } from './simple-icons-llvm.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLlvmComponent ],
    exports:      [ SimpleIconsLlvmComponent ],
    bootstrap:    []
})
export class SimpleIconsLlvmModule {}
